const translates = {
	en: {
		comment: 'Write comment'
	},
	ru: {
		comment: 'Написать комментарий'
	}
};
export default translates;